'use client';
import { memoize } from '@s7/memo';
import { isFunction } from '@s7/utils';
import { defaultPropObject } from '../../constants.js';

/*
 * Мемоизация эмиттера стилей призвана ускорить создание базового объекта стилей.
 * */ var createMemoizedEmittersEvaluator = function(emitter) {
    return isFunction(emitter) ? memoize(function(theme, params, variations) {
        return emitter(theme, params || defaultPropObject, variations || defaultPropObject);
    }, {
        /*
                   * Хэш темы создаётся при создании объекта темы с помощью mergeTheme.
                   * Кастомный сериализатор требуется для обеспечения эффективности по памяти.
                   * */ serializer: function serializer(param) {
            var theme = param[0], others = param.slice(1);
            return theme.__hash + JSON.stringify(others);
        }
    }) : function() {
        return emitter;
    };
};

export { createMemoizedEmittersEvaluator };
